import React, { Component } from 'react';

import './Streams.css'

class Video extends Component {
  timeout = null;

  shouldComponentUpdate(nextProps) {
    if (!this.refs.stream || !this.refs.stream.srcObject) return true;

    if (nextProps.stream && this.refs.stream.srcObject && nextProps.stream.id != this.refs.stream.srcObject.id) {
      return true;
    }
    
    if (!nextProps.stream) {
      return true;
    }

    return false;
  }

  componentDidMount() {
    this.refs.stream.addEventListener('playing', () => {
      if (this.refs.stream) this.refs.stream.setAttribute('data-orientation', this.refs.stream.videoWidth > this.refs.stream.videoHeight ? 'landscape' : 'portrait');
    });
  }

  componentDidUpdate() {
    console.log("Received props");
    let nextProps = this.props;

    if (!this.props.stream) {
      clearTimeout(this.timeout);
      return;
    }

    let setStream = () => {
      let currentStream = this.refs.stream.srcObject;
      this.refs.stream.srcObject = nextProps.stream;

      if (this.props.muted) {
        this.refs.stream.setAttribute('muted', this.props.muted);
      }
      else {
        this.refs.stream.removeAttribute('muted');
      }
      this.refs.stream.setAttribute('playsinline', '1');
      this.refs.stream.setAttribute('autoplay', '1');

      let id = nextProps.stream.getVideoTracks().length ? nextProps.stream.getVideoTracks()[0].id : 'no tracks';
      console.log(this.props.className, "Reading", id);

      const playPromise = this.refs.stream.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.log("ERROR", id, error);
        });
      }

      nextProps.stream.onaddtrack = (e) => { console.log("Stream track added"); };
      console.log("Added stream", nextProps.stream);
    }

    setStream();

    if (this.timeout !== null) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    this.timeout = setTimeout(() => {
      if (this.refs.stream && this.refs.stream.currentTime == 0) {
        // revert to stream before
        console.log("Not playing");
        this.props.onError();
      }
    }, 2000);

    window.stream = this.refs.stream.srcObject;
  }

  render() {
    return (<video {...this.props} ref="stream" playsInline></video>);
  }
};

class Streams extends Component {
  state = {
    big: false,
    zoomed: false
  }

  setBigScreen(kind) {
    this.setState({big: kind});
  }

  getBigScreen() {
    const streamsOnline = this.getStreamsOnline();

    if (streamsOnline.length == 2) {
      if (this.state.big == 'local' || this.state.big == 'remote') {
        return this.state.big;
      }
      else {
        return 'remote';
      }
    }
    else if (streamsOnline.length == 1) {
      if (this.props.remoteStream) return 'remote';
      else if (this.props.localStream) return 'local';
    }
    else {
      return false;
    }
  }

  getStreamsOnline() {
    return [this.props.remoteStream, this.props.localStream].filter(r => !!r);
  }

  toggleZoom() {
    this.setState({
      zoomed: !this.state.zoomed
    });
  }

  componentDidUpdate() {
    if (this.props.callStatus !== 'established' && this.getStreamsOnline().length == 2) {
      this.props.onStreamsRunning();
    }
  }

  render() {
    const mainScreen = this.getBigScreen();

    return (
      <div className={
          "streams"
          + (this.props.remoteStream ? ' hasremotestream' : '')
          + (this.props.localStream ? ' haslocalstream' : '')
          + (this.state.zoomed ? ' zoomed' : '')
        }>
          {mainScreen && this.props.remoteStream && <div
            className={"remoteStreamContainer" + (mainScreen == 'remote' ? ' bigStream' : ' smallStream')}
            onClick={() => mainScreen == 'remote' ? this.toggleZoom() : this.setBigScreen('remote')}
          >
            <Video className="remoteStream" stream={this.props.remoteStream} onError={() => this.props.onError('remote')} />
          </div>}
          {mainScreen && this.props.localStream && <div className={"localStreamContainer" + (mainScreen == 'local' ? ' bigStream' : ' smallStream')}
            onClick={() => mainScreen == 'local' ? this.toggleZoom() : this.setBigScreen('local')}
          >
            <Video className="localStream" stream={this.props.localStream} muted={true} onError={() => this.props.onError('local')} />
          </div>}
      </div>
    )
  }
};

export default Streams;


// WEBPACK FOOTER //
// ./src/shared/Streams.js


// WEBPACK FOOTER //
// ./src/shared/Streams.js